export const CLASS_NAMES = {
  container: 'flex w-full overflow-hidden',
  sidebarContainer: 'mt-18 ml-10 lg:ml-20 lg:absolute',
  sidebarInnerContainer:
    'flex flex flex-row justify-between items-center mt-2 mb-4 mr-4 md:flex-col md:items-start',
  contentContainer: 'flex flex-col my-auto flex-1 items-center',
  contentInnerContainer:
    'flex flex-row w-full justify-center px-0 lg:px-38 pt-18 flex-1 pb-18',
  content: 'flex flex-col flex-1 w-120 max-w-120',
};

export const STEP_CLASS_NAMES = {
  container: 'flex flex flex-row items-center md:mb-4 mr-2',
  number: {
    base: 'w-5 h-5 rounded-full border-2 flex items-center justify-center text-style-g-em mr-2',
    '@active': {
      true: 'border-purple-100 text-purple-400',
      false: 'border-neutral-200 text-neutral-600',
    },
  },
  label: {
    base: 'text-style-g-em whitespace-nowrap',
    '@active': {
      true: 'text-purple-400',
      false: 'text-neutral-500',
    },
  },
};
